import { ReactNode, useContext } from "react";
import { ErrorUtils } from "../../utils";
import { errorDataLoading } from "../shared/appStates/appStates";
import { AvisLoader } from "../shared/components";
import { AvisContext } from "../shared/context/AvisContext";
import { ErrorPage } from "../shared/error/ErrorPage";

interface IPublicHOCProps {
  children?: ReactNode;
}

export function PublicHOC(props: Readonly<IPublicHOCProps>) {
  const { children } = props;
  const { isLoading, ctxPortalSettings, res } = useContext(AvisContext);

  if (isLoading && !ctxPortalSettings) return <AvisLoader />;

  if (errorDataLoading.value) {
    return (
      <ErrorPage
        info={
          ErrorUtils.basicErrorResponseCheck(errorDataLoading.value, res)
            ?.errorMessage
        }
      />
    );
  }
  return children;
}
